import { render, staticRenderFns } from "./v-checkbox-channels.vue?vue&type=template&id=d6c23f96&scoped=true&"
import script from "./v-checkbox-channels.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-channels.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-channels.vue?vue&type=style&index=0&id=d6c23f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c23f96",
  null
  
)

export default component.exports